import { get5x5StringDataDefinition } from "../Testing/TestData";
import {
    DisplayEditModeTemplate,
    DisplayLayerEditModeTemplate,
    DisplayModeTemplate,
    EditModeTemplate,
    GridTestTemplate,
} from "./CommonStoryTemplates";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { StoryNode } from "../../StoryBook/StoryData";
import React from "react";

let griddef = get5x5StringDataDefinition(false, ["String", "String1", "String2", "String3"]);

let def = new DataDefinition();
let fdef = new StringDataDefinition("string");
fdef.validValues = ["String", "String1", "String2", "String3"];
def.fields.push(fdef);

DataUtilities.set(def.getValueObject(), fdef.name, "String");

let typeName = "String (Valid Values)";

export const StringValidValuesEditorStories = [
    new StoryNode(
        () => {
            return <GridTestTemplate definition={griddef}></GridTestTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Grid",
    ),
    new StoryNode(
        () => {
            return <DisplayModeTemplate definition={def}></DisplayModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Mode",
    ),
    new StoryNode(
        () => {
            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayEditModeTemplate definition={def}></DisplayEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={def}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Layer Edit Mode",
    ),
];
